import { create } from "zustand"

type ChatRequestTakeOver = { patientId: string; patientName: string }

interface ChatRequestTakeOverState {
  requestTakeOver?: ChatRequestTakeOver
  setRequestTakeOver: (requestTakeOver?: ChatRequestTakeOver) => void
}

export const useChatRequestTakeOverStore = create<ChatRequestTakeOverState>()((set) => ({
  requestTakeOver: undefined,
  setRequestTakeOver: (requestTakeOver) => set({ requestTakeOver }),
}))
